// Angular imports
import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';

// 3rd party imports
import { DxDataGridComponent } from 'devextreme-angular';

// Service imports
import { CiraHelpService } from '../../../../_services/shared-services/cira-help.service';
import { ContextManagerService } from '../../../../_services/data-services/context-manager.service';

// Model imports
import { UserDashboardItemResultDto } from '../../../_models/user-dashboard-item-result-dto';
import { PropertyCommunityInfoResultDto } from '../../../../_models/property-community-info-result-dto';
import { UserDashboardProxyListResultDto } from '../../../_models/user-dashboard-proxy-list-result-dto';

@Component({
    selector: 'app-user-dashboard-details',
    templateUrl: './user-dashboard-details.component.html',
    styleUrls: ['./user-dashboard-details.component.scss']
})
export class UserDashboardDetailsComponent implements OnInit, AfterViewInit {
    @ViewChild('dashboardGrid', { static: false }) dashboardGrid: DxDataGridComponent;

    @Input() selectedUser: UserDashboardProxyListResultDto;
    @Input() selectedViewOption: any;
    @Input() dashboardDetails: UserDashboardItemResultDto[];
    @Input() filterField: string;

    selectedContext: PropertyCommunityInfoResultDto;

    constructor(private readonly ciraHelp: CiraHelpService, private readonly contextService: ContextManagerService) {}

    ngOnInit(): void {
        this.selectedContext = this.contextService.getSelectedContext();
        this.contextService.getContext().subscribe(() => {
            this.selectedContext = this.contextService.getSelectedContext();
        });
    }

    ngAfterViewInit(): void {
        if (!!this.filterField) {
            this.dashboardGrid.instance.columnOption(this.filterField, {
                selectedFilterOperation: '>',
                filterValue: 0
            });
        }
        this.dashboardGrid.instance.repaint();
    }

    onHelpIconClick(rec: UserDashboardItemResultDto): void {
        const helpUrl = this.ciraHelp.getHelpLink(
            null,
            rec.helpKey,
            !!this.selectedContext ? this.selectedContext.communityId : null
        );
        this.ciraHelp.showHelp(helpUrl);
    }
}
